import { createAction, props } from '@ngrx/store';
import { AuthUserModel } from '@shared/models/auth/auth-user.model';

export enum AuthActionType {
  GET_USER_DATA_FROM_STORAGE = '[Get User] Get User Data From Storage'
}

export const getUserDataFromStorageAction = createAction(
  AuthActionType.GET_USER_DATA_FROM_STORAGE,
  props<AuthUserModel>()
);

export const authActions = {
  getUserDataFromStorageAction
};
